export const hotelTypes = [
  "All Exclusive",
  "Flash Deals",
  "Luxury",
  "Family",
  "Romantic",
  "Beach Villa",
  "Budget",
  "Beach Resort",
  "All Inclusive",
  "All Exclusive Family",
  "All Exclusive Couple",
  "Couple",
  "Honeymoon",
  "Last Minute",
  "Beach"
];

export const hotelFacilities = [
  "Free WiFi",
  "Parking",
  "Airport Shuttle",
  "Family Rooms",
  "Non-Smoking Rooms",
  "Outdoor Pool",
  "Spa",
  "Fitness Center",
];

export const vacationType =[

]
